import CargarDocumentoSoluccionCosteada from "@/erp/venta-corporativa/solucion_costeada/shared/componente/cargar_documento_soluccion_costeada/CargarDocumentoSoluccionCosteada";
import {
  BucketAwtENUM,
  EstadoFactibilidadCorporativaENUM,
  gridSizeMdLg12,
  gridSizeMdLg3,
  gridSizeMdLg4,
  gridSizeMdLg6,
  gridSizeMdLg9,
  ROUTER_PATHS,
  texto,
  useTableColumnsInventario,
  useUploadFile,
} from "@/shared";
import { useFetchCoberturasSector } from "@/shared/actions/erp";
import { useFetchPutFactibilidadCorporativo } from "@/shared/actions/erp/factibilidad_corporativo/factibilidad_corporativo.actions";
import { useGetPlanCorporativo } from "@/shared/actions/erp/planes";
import {
  CustomAutocomplete,
  CustomAutocompleteArrString,
  CustomNumberTextField,
  CustomTextArea,
  CustomTextAreaNoForm,
  CustomTextField,
  // CustomTextAreaNoForm,
  CustomTextFieldNoForm,
  CustomTextFieldNumberComponente,
  SampleCheckbox,
  // SampleDatePicker,
  SampleTable,
  SingleFormBoxScene,
  TabTextLabel,
} from "@/shared/components/ui";
import { TiposTextFieldNumberEnum } from "@/shared/components/ui/CustomTextFieldNumberComponente";
import {
  CategoriaFCorporativaEnum,
  MaterialTransferido,
  PlanesCorporativos,
  Sector,
  SubmascaraRedEnum,
  TIPO_PLAN_CORPORATIVO_CHOICE,
} from "@/shared/interfaces";
import {
  IFactibilidadCorporativo,
  IFactibilidadCorporativoParams,
} from "@/shared/interfaces/erp/factibilidad_corporativo";
import {
  IPlanesTVMAX,
  IPreventaCorporativoForm2,
  PLANESTVMAX_OPTIONS,
} from "@/shared/interfaces/erp/preventa/preventa_corporativo.interface";

import { MaterialesKey, useMaterialesUtilizadosStore } from "@/store/erp";
import { ExpandMore } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  Typography,
} from "@mui/material";
import dayjs from "dayjs";
// import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

type InspeccionFCorporativoPageProps = {
  title: string;
  // dataProspecto: IDataProspecto;
  dataPreventa: IPreventaCorporativoForm2;
  dataFactibilidadCorporativa?: IFactibilidadCorporativo;
  updateFactibilidad: boolean;
  showSaveButton?: boolean;
};

export default function InspeccionFCorporativoPage({
  title,
  // dataPreventa,
  dataPreventa,
  dataFactibilidadCorporativa,
}: InspeccionFCorporativoPageProps) {
  const navigate = useNavigate();
  const RETURN_URL_INSPECCION_FACTIBILIDADCORPORATIVA =
    ROUTER_PATHS.noc.inspeccionCorporativoNav;

  const [selectedImage, setSelectedImage] = useState<File | null>(null);

  ///* Store y hooks
  const { handleUploadFile } = useUploadFile();

  const ingresoProductos = useMaterialesUtilizadosStore(
    (s) => s.ingresoProductos,
  );
  const clearSelectedItems = useMaterialesUtilizadosStore(
    (s) => s.clearSelectedItems,
  );
  const copyArray = useMaterialesUtilizadosStore((s) => s.copyArray);

  const { mutate: mutatePutFactibilidadCorporativa } =
    useFetchPutFactibilidadCorporativo({
      enableSuccessAlert: true,
      navigate,
      returnUrl: RETURN_URL_INSPECCION_FACTIBILIDADCORPORATIVA,
    });

  const { columnsItemFactibilidadCorporativaNoEdit } =
    useTableColumnsInventario({
      key: MaterialesKey.ingresoProductos,
    });

  const { columnsItemServiciosDigitalesFactibilidad } =
    useTableColumnsInventario({
      key: MaterialesKey.serviciosAdicionalesDigitales,
    });

  const serviciosAdicionalesDigitales = useMaterialesUtilizadosStore(
    (s) => s.serviciosAdicionalesDigitales,
  );

  const setSelectedItems = useMaterialesUtilizadosStore(
    (s) => s.setSelectedItems,
  );

  ///* Form
  const form = useForm<IPreventaCorporativoForm2>({});
  const {
    formState: { errors },
  } = form;

  const { handleSubmit, reset, control } = form;

  useEffect(() => {
    setSelectedItems(
      dataPreventa?.servicios_adicionales || [],
      MaterialesKey.serviciosAdicionalesDigitales,
    );

    reset({
      ...dataPreventa,
      ...dataFactibilidadCorporativa,
    });
  }, []);

  useEffect(() => {
    if (dataFactibilidadCorporativa) {
      copyArray(
        dataFactibilidadCorporativa.detalles,
        MaterialesKey.ingresoProductos,
      );
    }
    return () => {
      clearSelectedItems(MaterialesKey.ingresoProductos);
    };
  }, [dataPreventa, dataFactibilidadCorporativa]);

  const { data: sectorsByZonePaging } = useFetchCoberturasSector({
    zona: form.getValues().zona!,
    page_size: 1000,
    cobertura: true,
    estado: true,
  });

  ///* STATES ------------
  const [loadPlanesCorporativos, setLoadPlanesCorporativos] = useState(false);
  const [DataPlanSelected, setDataPlanSelected] = useState<
    PlanesCorporativos[]
  >([]);

  const {
    data: dataPlanesCorporativos,
    isLoading: isLoadingPlanesCorporativos,
  } = useGetPlanCorporativo(
    {
      page_size: 100,
      tipo_plan: form.watch().tipo_plan!,
    },
    loadPlanesCorporativos,
  );

  useEffect(() => {
    if (form.watch().tipo_plan) {
      setLoadPlanesCorporativos(true);
    }
  }, [form.watch().tipo_plan]);

  // ===========================================================================
  // POSTS USEEFFECT
  // ===========================================================================
  useEffect(() => {
    if (dataPlanesCorporativos?.code == 200) {
      const auxDataPlanesCorporativos =
        dataPlanesCorporativos?.data.data.filter(
          (x) => x.codigo == dataPreventa.plan,
        );

      if (auxDataPlanesCorporativos) {
        setDataPlanSelected(auxDataPlanesCorporativos);
      }
    }
  }, [dataPlanesCorporativos]);
  //**
  // HANDLERS */
  const onSaveFactibilidadCorporativa = async () => {
    reset({
      ...form.getValues(),
      observacion_inspeccion_factibilidad: form
        .getValues()
        ?.observacion_inspeccion_factibilidad?.toUpperCase(),
    });

    const sendForm: IFactibilidadCorporativoParams = {
      id_factibilidad_coorporativa:
        dataFactibilidadCorporativa!.id_factibilidad_coorporativa,
      observaciones: {
        ...dataFactibilidadCorporativa!.observaciones,
        observacion_inspeccion_factibilidad:
          form.getValues()?.observacion_inspeccion_factibilidad,
      },
      estado_factibilidad: EstadoFactibilidadCorporativaENUM.INSPECCIONADO,
      fecha_inspeccion: new Date(),
    };

    if (selectedImage) {
      const [respAnexo1] = await Promise.all([
        handleUploadFile(selectedImage!, BucketAwtENUM.INSPECCION_CORPORATIVO),
      ]);
      const urlAnexoInspeccion = respAnexo1.url;
      sendForm.observaciones.file_observacion_inspeccion_factibilidad =
        urlAnexoInspeccion;
    }

    mutatePutFactibilidadCorporativa(sendForm);
    return;
  };

  // useLoaders(isPending);
  const [expanded, setExpanded] = useState<number | null>(null);

  const handleChange =
    (panel: number) => (event: React.SyntheticEvent, isExpanded: boolean) => {
      event.preventDefault();
      setExpanded(isExpanded ? panel : null);
    };

  return (
    <>
      <SingleFormBoxScene
        titlePage={title}
        onCancel={() => {
          navigate(ROUTER_PATHS.noc.inspeccionCorporativoNav);
        }}
        onSave={handleSubmit(onSaveFactibilidadCorporativa)}
        saveTextBtn="Enviar a Factibilidad"
      >
        {dataFactibilidadCorporativa?.observacion_rechazo &&
          dataFactibilidadCorporativa?.observacion_rechazo?.length > 0 && (
            <Accordion
              expanded={expanded === 1}
              onChange={handleChange(1)}
              sx={{ width: "100%", border: "1px solid #ccc" }}
            >
              <AccordionSummary
                expandIcon={<ExpandMore />}
                aria-controls="panel3-content"
                id="panel3-header"
              >
                <TabTextLabel
                  text={"Observación Último Rechazo"}
                  mt={0}
                  pb={0}
                  pl={0}
                  pt={0}
                />
              </AccordionSummary>
              <AccordionDetails>
                <Typography>
                  Motivo:{" "}
                  {
                    dataFactibilidadCorporativa?.observacion_rechazo?.at(-1)
                      ?.motivo
                  }
                </Typography>
                <Typography>
                  Observación:{" "}
                  {
                    dataFactibilidadCorporativa?.observacion_rechazo?.at(-1)
                      ?.observacion
                  }
                </Typography>
                <Typography>
                  Fecha:{" "}
                  {dayjs(
                    dataFactibilidadCorporativa?.observacion_rechazo?.at(-1)
                      ?.fecha,
                  ).format("DD/MM/YYYY HH:mm:ss")}
                </Typography>
              </AccordionDetails>
            </Accordion>
          )}
        <>
          <>
            <Grid container spacing={2} paddingTop={4}>
              <Grid container item {...gridSizeMdLg12} spacing={3}>
                <Grid item {...gridSizeMdLg12} display={"flex"}>
                  {dataPreventa?.tipo_plan ? (
                    <Typography>
                      Cliente <b>{dataPreventa?.tipo_plan}</b>
                    </Typography>
                  ) : null}
                </Grid>
                <Grid item {...gridSizeMdLg12} display={"flex"}>
                  <Typography variant="h6">Detalles del Cliente</Typography>
                </Grid>
                <Grid item container spacing={2} {...gridSizeMdLg12}>
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"Razon Social"}
                    defaultValue={
                      form.getValues()?.prospecto_corporativo_data?.razon_social
                    }
                    value={
                      form.getValues()?.prospecto_corporativo_data?.razon_social
                    }
                    shrink={
                      !!form.getValues()?.prospecto_corporativo_data
                        ?.razon_social
                    }
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNoForm
                    required={false}
                    disabled={true}
                    defaultValue={
                      form.getValues()?.prospecto_corporativo_data
                        ?.nombre_comercial || "N/A"
                    }
                    size={gridSizeMdLg6}
                    label={"Nombre Comercial"}
                    shrink={
                      !!form.getValues()?.prospecto_corporativo_data
                        ?.nombre_comercial
                    }
                  />
                  <CustomTextFieldNoForm
                    disabled={true}
                    label={"RUC"}
                    defaultValue={
                      form.getValues()?.prospecto_corporativo_data
                        ?.identificacion
                    }
                    value={
                      form.getValues()?.prospecto_corporativo_data
                        ?.identificacion
                    }
                    shrink={
                      !!form.getValues()?.prospecto_corporativo_data
                        ?.identificacion
                    }
                    size={gridSizeMdLg6}
                  />
                  <CustomTextFieldNumberComponente
                    size={gridSizeMdLg6}
                    type={TiposTextFieldNumberEnum.CELULAR}
                    label={texto.celular}
                    error={errors.celular}
                    helperText={errors.celular?.message}
                    control={control}
                    name="celular_1"
                    disabled
                    defaultValue={
                      form.getValues()?.celular ||
                      form.getValues()?.celular ||
                      ""
                    }
                  />
                  <CustomTextFieldNumberComponente
                    size={gridSizeMdLg6}
                    type={TiposTextFieldNumberEnum.CELULAR}
                    label={`${texto.celular} 2`}
                    error={errors.celular_2}
                    helperText={errors.celular_2?.message}
                    control={control}
                    name="celular_2"
                    required={false}
                    disabled
                    defaultValue={
                      form.getValues()?.celular_2 ||
                      form.getValues()?.celular_2 ||
                      ""
                    }
                  />
                </Grid>
                <CustomTextAreaNoForm
                  label="Observación Vendedor"
                  value={
                    dataPreventa?.observaciones?.observacion_vendedor ||
                    dataFactibilidadCorporativa?.preventa_corporativa_data
                      ?.observaciones?.observacion_vendedor ||
                    dataFactibilidadCorporativa?.prospecto_corporativo_data
                      ?.observaciones?.observacion_vendedor ||
                    "N/A"
                  }
                  shrink
                  size={gridSizeMdLg12}
                  required={false}
                  disabled={true}
                  autoGrow
                  maxRows={14}
                />
                <CustomTextAreaNoForm
                  label="Observación Prefactibilidad"
                  value={
                    dataPreventa?.observaciones?.observacion_prefactibilidad ||
                    dataFactibilidadCorporativa?.preventa_corporativa_data
                      ?.observaciones?.observacion_prefactibilidad ||
                    dataFactibilidadCorporativa?.prospecto_corporativo_data
                      ?.observaciones?.observacion_prefactibilidad ||
                    "N/A"
                  }
                  shrink
                  size={gridSizeMdLg12}
                  required={false}
                  disabled={true}
                  autoGrow
                  maxRows={14}
                />
                <CustomTextAreaNoForm
                  label="Observación Preventa"
                  value={
                    dataPreventa?.observaciones?.observacion_preventa ||
                    dataFactibilidadCorporativa?.preventa_corporativa_data
                      ?.observaciones?.observacion_preventa ||
                    dataFactibilidadCorporativa?.prospecto_corporativo_data
                      ?.observaciones?.observacion_preventa ||
                    "N/A"
                  }
                  shrink
                  size={gridSizeMdLg12}
                  required={false}
                  disabled={true}
                  autoGrow
                  maxRows={14}
                />
                <CustomTextAreaNoForm
                  label="Observación Factibilidad"
                  value={
                    dataFactibilidadCorporativa?.observaciones
                      ?.observacion_factibilidad || "N/A"
                  }
                  shrink={true}
                  size={gridSizeMdLg12}
                  required={false}
                  disabled={true}
                  autoGrow
                  maxRows={14}
                />

                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg12}
                >
                  <CustomTextField
                    control={control}
                    name="ejecutivo_comercial"
                    defaultValue={form.getValues().ejecutivo_comercial}
                    size={gridSizeMdLg6}
                    label={"Ejecutivo Comercial"}
                    error={undefined}
                    helperText={undefined}
                    disabled={true}
                  />

                  <CustomTextField
                    control={control}
                    name="tecnico_responsable"
                    defaultValue={form.getValues().tecnico_responsable}
                    required={false}
                    size={gridSizeMdLg6}
                    label={"Técnico Responsable del Cliente"}
                    error={undefined}
                    helperText={undefined}
                    disabled
                  />

                  <CustomTextField
                    control={control}
                    name="email_tecnico_responsable"
                    type="email"
                    defaultValue={form.getValues().email_tecnico_responsable}
                    required={false}
                    size={gridSizeMdLg6}
                    label={"Email Técnico Responsable del Cliente"}
                    error={undefined}
                    helperText={undefined}
                    disabled
                  />

                  <Grid item container {...gridSizeMdLg3} spacing={3}>
                    <SampleCheckbox
                      size={gridSizeMdLg6}
                      label="¿Tiene CDNs?"
                      control={form.control}
                      name="tiene_cdns"
                      defaultValue={form.getValues().tiene_cdns || false}
                      onChangeValue={(e) => {
                        form.reset({ ...form.getValues(), tiene_cdns: e });
                      }}
                      disabled
                    />
                  </Grid>
                  {form.watch().tiene_cdns && (
                    <>
                      <CustomTextField
                        control={control}
                        name="cdns_detalle"
                        defaultValue={form.getValues().cdns_detalle}
                        size={gridSizeMdLg3}
                        label={"Detalle de CDNs"}
                        error={undefined}
                        helperText={undefined}
                        disabled
                      />
                    </>
                  )}
                </Grid>

                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg12}
                >
                  <CustomTextFieldNoForm
                    defaultValue={
                      dataPreventa.coordenada_fusion ||
                      dataFactibilidadCorporativa?.preventa_corporativa_data
                        ?.coordenada_fusion ||
                      ""
                    }
                    size={gridSizeMdLg6}
                    label={"Coordenadas de Fusión"}
                    disabled
                  />

                  <CustomTextFieldNoForm
                    defaultValue={
                      dataPreventa.direccion_fusion ||
                      dataFactibilidadCorporativa?.preventa_corporativa_data
                        ?.direccion_fusion ||
                      ""
                    }
                    size={gridSizeMdLg6}
                    label={"Dirección de Fusión"}
                    disabled
                  />
                </Grid>
              </Grid>

              <Grid container item {...gridSizeMdLg12} spacing={3} pt={3}>
                <Grid item {...gridSizeMdLg12} display={"flex"}>
                  <Typography variant="h6">Detalles de Enlace</Typography>
                </Grid>
                <Grid item container spacing={3} {...gridSizeMdLg6}>
                  <CustomTextFieldNoForm
                    size={gridSizeMdLg12}
                    label={"Medio / Última Milla"}
                    defaultValue={form.getValues().medio_ultima_milla}
                    value={form.getValues().medio_ultima_milla}
                    shrink={!!form.getValues().medio_ultima_milla}
                    disabled={true}
                  />
                  <CustomTextFieldNoForm
                    size={gridSizeMdLg12}
                    label={"Tipo de Puertos para Recibir el Servicio"}
                    defaultValue={form.getValues().tipo_puerto_disponible}
                    value={form.getValues().tipo_puerto_disponible}
                    shrink={!!form.getValues().tipo_puerto_disponible}
                    disabled={true}
                  />
                </Grid>

                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg6}
                >
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Energía Regulada"
                    control={form.control}
                    name="energia_regulada"
                    defaultValue={form.getValues().energia_regulada || false}
                    disabled={true}
                  />
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Espacio Para Equipos"
                    control={form.control}
                    name="espacio_equipos"
                    defaultValue={form.getValues().espacio_equipos || false}
                    disabled={true}
                  />
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Zona Soterrada"
                    control={form.control}
                    name="zona_soterrada"
                    defaultValue={form.getValues().zona_soterrada || false}
                    disabled={true}
                  />
                  <SampleCheckbox
                    size={gridSizeMdLg6}
                    label="Instalación por Ductos"
                    control={form.control}
                    name="instalacion_ductos"
                    defaultValue={form.getValues().instalacion_ductos || false}
                    disabled={true}
                  />
                </Grid>

                <Grid {...gridSizeMdLg12} mt={2}>
                  <TabTextLabel text="Ubicación " />
                </Grid>
                <Grid
                  item
                  container
                  spacing={2}
                  justifyContent={"start"}
                  alignContent={"start"}
                  {...gridSizeMdLg12}
                >
                  <CustomTextFieldNoForm
                    defaultValue={form.getValues().coordenada_empresa}
                    value={form.getValues().coordenada_empresa}
                    shrink={!!form.getValues().coordenada_empresa}
                    size={gridSizeMdLg6}
                    label={"Coordenadas Empresa"}
                    disabled
                  />

                  <CustomTextFieldNoForm
                    defaultValue={form.getValues().direccion_empresa}
                    value={form.getValues().direccion_empresa}
                    shrink={!!form.getValues().direccion_empresa}
                    size={gridSizeMdLg6}
                    label={"Dirección Empresa"}
                    disabled
                  />

                  <CustomTextFieldNoForm
                    defaultValue={form.getValues().coordenada_servicio}
                    value={form.getValues().coordenada_servicio}
                    shrink={!!form.getValues().coordenada_servicio}
                    size={gridSizeMdLg6}
                    label={"Coordenadas Servicio"}
                    disabled
                  />

                  <CustomTextFieldNoForm
                    defaultValue={form.getValues().direccion_servicio}
                    value={form.getValues().direccion_servicio}
                    shrink={!!form.getValues().direccion_servicio}
                    size={gridSizeMdLg6}
                    label={"Dirección Servicio"}
                    disabled
                  />
                </Grid>
                {/* 
            // =================================================================
            // Ubicación validada por zona
            // =================================================================
            */}
                <Grid item container spacing={2} {...gridSizeMdLg12}>
                  {!form.getValues().sector_tentativo ? (
                    <CustomTextFieldNoForm
                      value={
                        sectorsByZonePaging?.data?.filter(
                          (x) => x.codigo == form.getValues().sector,
                        )?.[0]?.zona_data?.nombre || "N/A"
                      }
                      shrink
                      size={gridSizeMdLg6}
                      label={"Zona"}
                      disabled={true}
                    />
                  ) : null}
                  <CustomTextFieldNoForm
                    value={
                      form.getValues().sector_tentativo
                        ? form.getValues().provincia_data?.nombre
                        : sectorsByZonePaging?.data?.filter(
                            (x) => x.codigo == form.getValues().sector,
                          )?.[0]?.provincia_data?.nombre
                    }
                    shrink
                    size={gridSizeMdLg6}
                    label={"Provincia"}
                    disabled={true}
                  />
                  <CustomTextFieldNoForm
                    value={
                      form.getValues()?.sector_tentativo
                        ? form.getValues()?.ciudad_data?.nombre
                        : sectorsByZonePaging?.data?.filter(
                            (x) => x.codigo == form.getValues().sector,
                          )?.[0]?.ciudad_data?.nombre
                    }
                    shrink
                    size={gridSizeMdLg6}
                    label={"Ciudad"}
                    disabled={true}
                  />
                  {form.getValues().sector_tentativo ? (
                    <CustomTextFieldNoForm
                      value={form.getValues().sector_tentativo}
                      shrink
                      size={gridSizeMdLg6}
                      label={"Sector"}
                      disabled={true}
                    />
                  ) : (
                    <CustomAutocomplete<Sector>
                      size={gridSizeMdLg6}
                      label={"Sector"}
                      name="sector"
                      options={sectorsByZonePaging?.data || []}
                      defaultValue={form.getValues().sector}
                      isLoadingData={false}
                      control={form.control}
                      error={undefined}
                      helperText={undefined}
                      valueKey="alias" // name is the fk
                      actualValueKey="codigo"
                      disabled={true}
                    />
                  )}
                </Grid>
              </Grid>

              <Grid item container {...gridSizeMdLg12} spacing={3} pt={3}>
                <Grid item container {...gridSizeMdLg12} spacing={3}>
                  {/* <Grid item {...gridSizeMdLg12} display={"flex"}>
                  <Typography variant="h6">Formas de Pago</Typography>
                </Grid> */}

                  {/* ------------- Forma Pago Servicio */}
                  <Grid item container {...gridSizeMdLg12} spacing={3}></Grid>
                </Grid>

                <Grid item container {...gridSizeMdLg12} spacing={3}>
                  <Grid item container {...gridSizeMdLg12} spacing={3}>
                    <Grid container item>
                      <Typography variant="h6">
                        Detalles del Servicio
                      </Typography>
                    </Grid>
                    <CustomAutocompleteArrString
                      size={gridSizeMdLg6}
                      label={"Tipo de Servicio"}
                      name="tipo_plan"
                      options={TIPO_PLAN_CORPORATIVO_CHOICE}
                      defaultValue={form.getValues().tipo_plan}
                      isLoadingData={false}
                      control={control}
                      error={form.formState.errors.tipo_plan}
                      helperText={form.formState.errors.tipo_plan?.message}
                      disabled
                    />
                    <CustomAutocomplete<PlanesCorporativos>
                      size={gridSizeMdLg6}
                      label={`${form.getValues()?.plan_personalizado ? "Enlace Corporativa" : "Plan Corporativo"}`}
                      name="plan"
                      options={dataPlanesCorporativos?.data.data || []}
                      defaultValue={form.getValues().plan}
                      isLoadingData={isLoadingPlanesCorporativos}
                      control={form.control}
                      error={form.formState.errors.plan}
                      helperText={form.formState.errors.plan?.message}
                      valueKey="nombre" // name is the fk
                      actualValueKey="codigo"
                      disabled
                    />
                  </Grid>

                  <Grid
                    item
                    container
                    spacing={3}
                    {...gridSizeMdLg12}
                    justifyContent={"start"}
                    alignContent={"start"}
                  >
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.nombre_personalizado
                          : DataPlanSelected?.[0]?.nombre || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Nombre de plan"}
                      shrink={!!DataPlanSelected?.[0]?.nombre}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.tipo_plan_personalizado
                          : DataPlanSelected?.[0]?.tipo_plan || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Tipo de plan"}
                      shrink={!!DataPlanSelected?.[0]?.tipo_plan}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.permanencia_personalizado
                          : DataPlanSelected?.[0]?.permanencia || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Tiempo de Permanencia"}
                      shrink={!!DataPlanSelected?.[0]?.permanencia}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.capacidad_personalizado
                          : DataPlanSelected?.[0]?.capacidad || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Enlace (Mbps)"}
                      shrink={true}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.valor_personalizado
                          : DataPlanSelected?.[0]?.valor || ""
                      }
                      size={gridSizeMdLg6}
                      label={"Valor"}
                      shrink={true}
                      disabled={true}
                    />
                    <CustomTextFieldNoForm
                      value={
                        form.getValues()?.plan_personalizado
                          ? form.getValues().data_plan_personalizado
                              ?.costo_instalacion_personalizado
                          : DataPlanSelected?.[0]?.costo_instalacion || ""
                      }
                      size={gridSizeMdLg3}
                      label={`Valor Instalación ${!form.getValues()?.plan_personalizado ? "Referencial" : ""}`}
                      shrink={true}
                      disabled={true}
                    />
                    {!form.getValues()?.plan_personalizado ? (
                      <CustomNumberTextField
                        control={control}
                        name="valor_instalacion"
                        defaultValue={form.getValues().valor_instalacion}
                        size={gridSizeMdLg3}
                        label={"Valor de Instalación"}
                        error={errors.valor_instalacion}
                        helperText={errors.valor_instalacion?.message}
                        disabled
                      />
                    ) : null}
                    <CustomTextFieldNoForm
                      value={form.getValues().bonificacion}
                      size={gridSizeMdLg6}
                      label={"Bonificación (Mbps)"}
                      disabled={true}
                      shrink={!!form.getValues().bonificacion}
                    />
                    <CustomTextField
                      label={"Velocidad Total"}
                      name="velocidad_total"
                      defaultValue={
                        form.getValues().velocidad_total ||
                        DataPlanSelected?.[0]?.capacidad ||
                        ""
                      }
                      size={gridSizeMdLg6}
                      shrink={!!form.getValues().velocidad_total}
                      control={control}
                      error={errors.velocidad_total}
                      helperText={errors?.velocidad_total?.message}
                      disabled={true}
                    />
                    <CustomTextField
                      label={"Disponibilidad"}
                      name="disponibilidad"
                      defaultValue={form.getValues().disponibilidad}
                      size={gridSizeMdLg6}
                      shrink={!!form.getValues().disponibilidad}
                      control={control}
                      error={errors.disponibilidad}
                      helperText={errors?.disponibilidad?.message}
                      disabled={true}
                    />
                  </Grid>

                  <Grid
                    item
                    container
                    spacing={3}
                    {...gridSizeMdLg12}
                    justifyContent={"start"}
                    alignContent={"start"}
                  ></Grid>
                </Grid>
              </Grid>

              <Grid item container {...gridSizeMdLg12} spacing={3}>
                <Grid item {...gridSizeMdLg12} display={"flex"} mt={2}>
                  <Typography variant="h6">Servicios Adicionales</Typography>
                </Grid>
                <Grid
                  item
                  container
                  spacing={3}
                  {...gridSizeMdLg12}
                  justifyContent={"start"}
                  alignContent={"start"}
                >
                  <SampleTable<any>
                    columns={columnsItemServiciosDigitalesFactibilidad}
                    data={
                      serviciosAdicionalesDigitales || //.filter(x=>x.categoria_fcorporativa==CategoriaFCorporativaEnum.SERVICIOS_DIGITALES)
                      []
                    }
                  />
                </Grid>

                <Grid container item spacing={2} {...gridSizeMdLg12}>
                  <SampleCheckbox
                    size={gridSizeMdLg3}
                    label="Plan TVMAX"
                    control={form.control}
                    name="plan_tvmax"
                    defaultValue={!!form.getValues().plan_tvmax || false}
                    disabled={true}
                  />
                  {!!form.getValues().plan_tvmax ? (
                    <>
                      <Grid container item spacing={2} {...gridSizeMdLg9}>
                        <CustomAutocomplete<IPlanesTVMAX>
                          label="Planes TVMAX"
                          name="codigo_plan_tvmax"
                          options={PLANESTVMAX_OPTIONS}
                          valueKey="nombre"
                          actualValueKey="codigo"
                          defaultValue={
                            form.getValues().plan_tvmax?.codigo_plan_tvmax || ""
                          }
                          isLoadingData={false}
                          control={form.control}
                          error={form.formState.errors.codigo_plan_tvmax}
                          helperText={
                            form.formState.errors.codigo_plan_tvmax?.message
                          }
                          size={gridSizeMdLg4}
                          disabled
                        />
                        <Grid item {...gridSizeMdLg4}>
                          <CustomNumberTextField
                            control={form.control}
                            name="usuarios_plan_tvmax"
                            defaultValue={
                              form.getValues()?.plan_tvmax
                                ?.usuarios_plan_tvmax || 0
                            }
                            size={gridSizeMdLg12}
                            label={"Número de usuarios"}
                            error={form.formState.errors.usuarios_plan_tvmax}
                            helperText={
                              form.formState.errors.usuarios_plan_tvmax?.message
                            }
                            disabled
                          />
                        </Grid>
                        <Grid item {...gridSizeMdLg4}>
                          <CustomTextFieldNoForm
                            disabled
                            size={gridSizeMdLg12}
                            label={"Valor A Pagar Plan TVMAX"}
                            value={
                              form.getValues().plan_tvmax
                                ?.usuarios_plan_tvmax &&
                              form.getValues().plan_tvmax?.costo_plan_tvmax
                                ? (form.getValues().plan_tvmax
                                    ?.usuarios_plan_tvmax || 0) *
                                  (form.getValues().plan_tvmax
                                    ?.costo_plan_tvmax || 0)
                                : 0
                            }
                          />
                        </Grid>
                      </Grid>
                    </>
                  ) : null}
                </Grid>

                <Grid
                  item
                  container
                  spacing={3}
                  {...gridSizeMdLg12}
                  justifyContent={"start"}
                  alignContent={"start"}
                >
                  <CustomTextField
                    control={form.control}
                    name="num_ips_publicas"
                    defaultValue={form.getValues().num_ips_publicas}
                    size={gridSizeMdLg3}
                    label={"Número de IPs públicas"}
                    error={form.formState.errors.num_ips_publicas}
                    helperText={form.formState.errors.num_ips_publicas?.message}
                    disabled={true}
                  />
                  <CustomNumberTextField
                    control={form.control}
                    name="num_ips_publicas_facturadas"
                    defaultValue={form.getValues().num_ips_publicas_facturadas}
                    size={gridSizeMdLg3}
                    label={"Número de IPs públicas Facturadas"}
                    error={form.formState.errors.num_ips_publicas_facturadas}
                    helperText={
                      form.formState.errors.num_ips_publicas_facturadas?.message
                    }
                    disabled={true}
                  />
                  <CustomNumberTextField
                    control={form.control}
                    name="costo_valor_ip_facturado"
                    defaultValue={"20"}
                    size={gridSizeMdLg3}
                    label={"Valor IPs Facturadas ($)"}
                    error={form.formState.errors.costo_valor_ip_facturado}
                    helperText={
                      form.formState.errors.costo_valor_ip_facturado?.message
                    }
                    disabled={true}
                  />
                  <CustomTextFieldNoForm
                    value={
                      form.watch().num_ips_publicas_facturadas &&
                      form.getValues().costo_valor_ip_facturado
                        ? (
                            (parseFloat(
                              form.getValues().num_ips_publicas_facturadas,
                            ) || 1) *
                            (form.getValues().costo_valor_ip_facturado || 1)
                          ).toString()
                        : "0"
                    }
                    size={gridSizeMdLg3}
                    label={"Valor a Pagar ($)"}
                    disabled={true}
                  />

                  <CustomAutocompleteArrString
                    size={gridSizeMdLg6}
                    label={"Máscara de Subred"}
                    name="submascara_red"
                    options={SubmascaraRedEnum}
                    defaultValue={form.getValues().submascara_red}
                    isLoadingData={false}
                    control={control}
                    error={errors.submascara_red}
                    helperText={errors.submascara_red?.message}
                    disabled
                  />

                  {/* 
              // =============================================================================
              // Productos y observaciones
              // =============================================================================
              */}
                  <Grid item xs={12}>
                    <Grid item {...gridSizeMdLg12} display={"flex"} mt={2}>
                      <Typography variant="h6">Materiales y Equipos</Typography>
                    </Grid>
                    <SampleTable<MaterialTransferido>
                      rowNumber={true}
                      columns={columnsItemFactibilidadCorporativaNoEdit}
                      data={ingresoProductos.filter(
                        (x) =>
                          x.categoria_fcorporativa ==
                          CategoriaFCorporativaEnum.MATERIALESEQUIPOS,
                      )}
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Grid item {...gridSizeMdLg12} display={"flex"} mt={2}>
                      <Typography variant="h6">Equipos Adicionales</Typography>
                    </Grid>
                    <SampleTable<MaterialTransferido>
                      rowNumber={true}
                      columns={columnsItemFactibilidadCorporativaNoEdit}
                      data={ingresoProductos.filter(
                        (x) =>
                          x.categoria_fcorporativa ==
                          CategoriaFCorporativaEnum.EQUIPOSADICIONALES,
                      )}
                    />
                  </Grid>

                  <CustomTextArea
                    label="Observación Inspección"
                    name="observacion_inspeccion_factibilidad"
                    typeOfEntry="observacion"
                    autoGrow
                    maxRows={14}
                    control={form.control}
                    defaultValue={
                      form.getValues().observaciones
                        ?.observacion_inspeccion_factibilidad ?? ""
                    }
                    error={
                      form.formState.errors.observacion_inspeccion_factibilidad
                    }
                    helperText={
                      form.formState.errors.observacion_inspeccion_factibilidad
                        ?.message
                    }
                    required={false}
                  />
                  <CargarDocumentoSoluccionCosteada
                    idInput="anexo-inspeccion"
                    buttonText={"Anexo Inspección"}
                    selectedImage={selectedImage}
                    setSelectedImage={setSelectedImage}
                    accept=".pdf, .xlsx, image/*"
                    permiteImagen={true}
                  />

                  {/* PRV-002: Sección Información Adicional (Solo Lectura) */}
                  {(dataFactibilidadCorporativa?.area_responsable_inspeccion ||
                    dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional) && (
                    <Grid item xs={12} sx={{ mt: 3 }}>
                      <Typography
                        variant="h6"
                        sx={{
                          borderBottom: "2px solid #1976d2",
                          paddingBottom: 1,
                          marginBottom: 2,
                        }}
                      >
                        Información Adicional
                      </Typography>
                      <Grid container spacing={2}>
                        {dataFactibilidadCorporativa?.area_responsable_inspeccion && (
                          <Grid item xs={12} md={6}>
                            <CustomTextFieldNoForm
                              label="Área Responsable"
                              value={
                                dataFactibilidadCorporativa.area_responsable_inspeccion
                              }
                              disabled
                              shrink
                            />
                          </Grid>
                        )}
                        {dataFactibilidadCorporativa?.url_archivo_inspeccion_adicional && (
                          <Grid
                            item
                            xs={12}
                            md={6}
                            sx={{ display: "flex", alignItems: "center" }}
                          >
                            <a
                              target="_blank"
                              href={
                                dataFactibilidadCorporativa.url_archivo_inspeccion_adicional
                              }
                              rel="noreferrer"
                              style={{ textDecoration: "none" }}
                            >
                              <Typography
                                variant="body1"
                                sx={{
                                  color: "primary.main",
                                  textDecoration: "underline",
                                  cursor: "pointer",
                                }}
                              >
                                Ver/Descargar Documento de Inspección
                              </Typography>
                            </a>
                          </Grid>
                        )}
                      </Grid>
                    </Grid>
                  )}
                  {/* FIN PRV-002 */}
                </Grid>
              </Grid>
            </Grid>
          </>
        </>
      </SingleFormBoxScene>
    </>
  );
}
